import { useAtom } from "jotai";

import { ClientActiveSettingsAtom, useGlobalMMMStore } from "../mmm-provider";

export const useClientActiveSettings = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [clientActiveSettings, setClientActiveSettings] = useAtom(
    ClientActiveSettingsAtom,
    {
      store: GlobalMMMStore,
    },
  );

  return [clientActiveSettings, setClientActiveSettings] as const;
};
